import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page31/Key/E1answerKey.png",
    component: T6,
    // isHello:false,
    isHiddenCheck: true,
   
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Di chuyển thước đo góc để đo rồi viết số đo góc vào chỗ chấm.</span>
        <video src="Audios/guide/p30_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "-11px",
        inputTop: "374px",
        ResultProtractor:[
          {
            textResult: 90,
            styleResult:{
              top: -374,
              left:56
            }
          },
          {
            textResult: 90,
            styleResult:{
              top:-156,
              left:273
            },
          },
          {
            textResult: 180,
            styleResult:{
              top:-156,
              left:614
            }
          },
          {
            textResult: 180,
            styleResult:{
              top:-156,
              left:614
            },
          },
          {
            textResult: 120,
            styleResult:{
              top: -339,
              left: 559
            }
          },
          {
            textResult: 120,
            styleResult:{
              top:-153,
              left:897
            },
          },
          {
            textResult: 60,
            styleResult:{
              top:-344,
              left:1060
            },
          },
          {
            textResult: 60,
            styleResult:{
              top:-150,
              left:1150
            }
          },
        ],
        result: [
          {
            id: 0,
            top: 30, // top cây thước sau khi đặt vô hình
            left: -139, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 1,
            top: 33, // top cây thước sau khi đặt vô hình
            left: -139, // left cây thước sau khi đặt vô hình
            rotate: 90,  
          },
          {
            id: 2,
            top: 33, // top cây thước sau khi đặt vô hình
            
            left: 201, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 3,
            top: 33, // top cây thước sau khi đặt vô hình
            left: 201, // left cây thước sau khi đặt vô hình
            rotate: 180,
          },

          {
            id: 4,
            top: 37, // top cây thước sau khi đặt vô hình
            left: 485, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 5,
            top: 37, // top cây thước sau khi đặt vô hình
            left: 485, // left cây thước sau khi đặt vô hình
            rotate: 60,
          },
          {
            id: 6,
            top: 36, // top cây thước sau khi đặt vô hình
            left: 762, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 7,
            top: 33, // top cây thước sau khi đặt vô hình
            
            left: 761, // left cây thước sau khi đặt vô hình
            rotate: 122,
          },
        ],
      },
    ],
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        title: `
        <div><img src="img/FriendsPlus/Page25/Demo/1.jpg" style="height:30mm;margin-left:-70px;margin-top:-58px "/> </div>
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        
        <div style='display:flex; margin-bottom: 50px'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>1</b>
        	</div>
          Đo rồi nêu số đo của các góc sau:
        </div>
        
      <div style="position: relative; top: -49px">
        <img src="/img/FriendsPlus/Page31/E1/1.jpg"  style="height:7cm;margin-top:0px;position:absolute;top:0px;left:0px" >

        <div
          style="
            position: absolute;
            left: 54px;
            top: 193px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 395px;
            top: 196px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 678px;
            top: 199px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 956px;
            top: 197px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
      </div>
      <div
          id="protractor"
          style="position: absolute;top: 269px;left: 214px;width: 400px; height: 420px;z-index: 1"
        >
        <img
        src="/img/test/protractor-removebg-preview3.png"
        style="width: 400px"
        alt="image"
      />
        </div>
      <div style='width: 1000px; height: 800px'>
      <table style="position: relative; border-collapse: collapse; margin: 20px auto; left: 372px; top: 210px">
        <tr>
          <th style="border: 1px solid black; padding: 8px; text-align: left;">Góc</th>
          <th style="border: 1px solid black; padding: 8px; text-align: left;">Số đo góc</th>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">a) Góc đỉnh O, cạnh OA, OB</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='4'><sup>o</sup></td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">b) Góc đỉnh I, cạnh IM, IN</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='5'><sup>o</sup></td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">c) Góc đỉnh E, cạnh EC, ED</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='6'><sup>o</sup></td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">d) Góc đỉnh K, cạnh KG, KP</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='7'><sup>o</sup></td>
        </tr>
      </table>
      </div>
        `,
        answer: ["90", "180", "120", "60"],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    isHello:false,
    exerciseKey: "img/FriendsPlus/Page31/Key/E2answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Di chuyển thước đo góc để đo rồi viết số đo góc vào chỗ chấm.</span>
        <video src="Audios/guide/p30_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "410px",
        inputTop: "363px",
        ResultProtractor:[
          {
            textResult: 90,
            styleResult:{
              top: -231,
              left:-492
            }
          },
          {
            textResult: 90,
            styleResult:{
              top:-10,
              left:-273
            },
          },
          {
            textResult: 90,
            styleResult:{
              top:-333,
              left:-280
            }
          },
          {
            textResult: 90,
            styleResult:{
              top:-116,
              left:-54
            },
          },
          {
            textResult: 120,
            styleResult:{
              top:-230,
              left:-290
            }
          },
          {
            textResult: 120,
            styleResult:{
              top:-38,
              left:50
            },
          },
          {
            textResult: 120,
            styleResult:{
              top:-310,
              left:-90
            },
          },
          {
            textResult: 120,
            styleResult:{
              top:-114,
              left:239
            }
          },
        ],
        result: [
          {
            id: 0,
            top: -57, // top cây thước sau khi đặt vô hình
            left: -44, // left cây thước sau khi đặt vô hình
            rotate: -90,
          },
          //Case S-2
          {
            id: 1,
            top: -57, // top cây thước sau khi đặt vô hình
            left: -44, // left cây thước sau khi đặt vô hình
            rotate: 180,
          },
          {
            id: 2,
            top: 63, // top cây thước sau khi đặt vô hình
            left: -45, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
           //Case D-2
           {
            id: 3,
            top: 63, // top cây thước sau khi đặt vô hình
            left: -45, // left cây thước sau khi đặt vô hình
            rotate: 90,
          },
          
          
          

          {
            id: 4,
            top: -57, // top cây thước sau khi đặt vô hình
            left: 175, // left cây thước sau khi đặt vô hình
            rotate: -121,
          },
          //Case G-2
          {
            id: 5,
            top: -57, // top cây thước sau khi đặt vô hình
            left: 175, // left cây thước sau khi đặt vô hình
            rotate: 180,
          },{
            id: 6,
            top: 61, // top cây thước sau khi đặt vô hình
            left: 246, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          
          {
            id: 7,
            top: 61, // top cây thước sau khi đặt vô hình
            left: 246, // left cây thước sau khi đặt vô hình
            rotate: 59,
          },
        ],
      },
    ],
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        title: `
        <div><img src="img/FriendsPlus/Page25/Demo/1.jpg" style="height:30mm;margin-left:-70px;margin-top:-60px "/> </div>
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        
        <div style='display:flex'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>2</b>
        	</div>
          Dùng thước đo góc để tìm số đo của các góc sau:
        </div>
        
        <div style="position: relative; margin-right: 100px; width: 1000px">
        <img src="/img/FriendsPlus/Page31/E2/3.jpg"  style="height:7cm;margin-top:50px;position:absolute;top:0px;left:0px" >
        

        <div
          style="
            position: absolute;
            left: 149px;
            top: 107px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 149px;
            top: 226px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 368px;
            top: 106px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 438px;
            top: 225px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
          "
          ></div>
      </div>
      <div
          id="protractor"
          style="position: absolute;top: 304px;left: 020px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview3.png"
            style="width: 400px"
            alt="image"
          />
        </div>

      <div style='width: 1000px; height: 800px'>
      <table style="position: relative; border-collapse: collapse; margin: 20px auto; left: 430px">
        <tr>
          <th style="border: 1px solid black; padding: 8px; text-align: left;">Góc</th>
          <th style="border: 1px solid black; padding: 8px; text-align: left;">Số đo góc</th>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">a) Góc đỉnh S, cạnh ST, SD </td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='4'><sup>o</sup></td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">b) Góc đỉnh D, cạnh DS, DL</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='5'><sup>o</sup></td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">c) Góc đỉnh G, cạnh GS, GL</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='6'><sup>o</sup></td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">d) Góc đỉnh L, cạnh LG, LC</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='7'><sup>o</sup></td>
        </tr>
      </table>
      </div>
        `,
        answer: ["90", "90", "120", "120"],
      },
    ],
  },
  3: {
    unit: "Review 2",
    id: "4WB-R2-P49-E5",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page31/Key/E3answerKey.png",
    component: Circle_Write,
    // checkUppercase: true,
    isHiddenCheck: true,
  
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chữ A, B, C, để chọn đáp án.</span>
        <video src="Audios/guide/p30_e3.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    titleQuestion: [
      {
        title: `
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    question: {
      Write: {
        isHiddenCheck: true,
        maxLength: 10,
        inputStyle: {
          width: 250,
          fontSize: 24,
          textAlign: "center",
          height: 29,
          paddingBottom: 10,
          textTransform: "uppercase",
        },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 5,
          // borderColor: "transparent",
          fontWeight: 700,
          color: "rgb(246,129,184)",
        },
        // initialWordStyle: { fontWeight: 'bold', border: 'none', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: {
          padding: 5,
          border: "2px solid black",
          borderRadius: "50%",
          // borderColor: "",
        },
        limitSelect: 1,
        listWords: [
          `A &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp; B &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp; C`,
        ],
        answers: ["0-4"],
        initialValue: [],
      },
      Layout: `
      <div style='display:flex'>
      	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
      	  <b>3</b>
      	</div>
        Chọn câu trả lời đúng.
      </div> 
      <div style='position: relative; margin-top: 30px'>
      <div>Bạn Rô-bốt vẽ các góc đỉnh O; cạnh OM, ON có số đo 60<sup>o</sup> và góc đỉnh O; cạnh ON, OP có số đo 90<sup>o</sup> để tạo thành góc đỉnh O; cạnh OM, OP.<br>
      Hỏi hình nào sau đây là hình Rô-bốt đã vẽ?
      </div>
      <img src='img/FriendsPlus/Page31/E3/1.jpg' style='width: 25cm; height: 7cm; margin-left: 100px; margin-bottom: 30px'><br>
      <div style='position: absolute; top: 388px; left: 251px'>
                <div><input id='0' type='Circle' /></div>

        
	    </div>
      `,
    },
  },
  4: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E1",
    audio: "",
    video: "",
    isHello:true,  
    // protractor: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page31/Key/E4answerKey.jpg",
    component: T6,
    // inputSize: 900,
    maxLength: 300,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "2px dotted gray",
      fontSize: "24px",
      textAlign: "center",
    },
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chỗ chấm để điền câu trả lời.</span>
        <video src="Audios/guide/p30_e4.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    textareaStyle: {
      // background: 'none',
      width: 900,
      fontSize: 24,
      // height: 70,
      paddingTop: 5,
      textAlign: "left",
    },
    titleQuestion: [
      {
        title: `
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex; align-items: center; max-width: 1000px'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:70px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>4</b>
        	</div>
          Em hãy tìm một số hình ảnh về góc nhọn, góc tù, góc vuông có ở những đồ vật quanh em như: bàn ghế, ê ke, compa...
        </div> <br><br>
        
				<div>
        <b>Một số đồ vật có hình ảnh góc nhọn, góc tù, góc vuông là : </b>
        <span style=''><textarea id='0' rows='3'></span> 
        </div>
				
				</div>
				
        `,
        answer: [""],
      },
    ],
  },
};

export default json;
